export const isChangeAgentEnabled = async (): Promise<boolean> => {
  return true;
};

export const isAdminAgentEnabled = async (): Promise<boolean> => {
  let isEnabled = process.env.REACT_APP_ADMIN_COPILOT_ENABLED === 'true';
  if (!isEnabled) {
    const changeAgentEnabled = await isChangeAgentEnabled();
    isEnabled = !changeAgentEnabled;
  }
  return isEnabled;
};
